<mat-tab-group
  mat-stretch-tabs="true"
  mat-align-tabs="start"
  [selectedIndex]="selectedTabIndex()"
  (selectedIndexChange)="onTabChange($event)"
>
  <mat-tab label="Overview">
    <div class="overview">
      @if (websiteData(); as data) {
        <app-website-information
          [websiteData]="data"
          (manageWordpress)="openWordpressDialog()"
          (createStaging)="openStagingDialog()"
          (addAlias)="openAliasDialog()"
          (addSubdomain)="openSubdomainDialog()"
          (showLogs)="openLogsDialog()"
          (disableWebsite)="toggleSiteStatus('DISABLED')"
          (enableWebsite)="toggleSiteStatus('ACTIVE')"
          (renameMain)="openRenameDialog()"
          (deleteWebsite)="deleteWebsite()"
        ></app-website-information>

        <div class="row">
          <app-site-disk-usage
            [websiteData]="data"
            (syncUsage)="syncWebsiteDiskUsage()"
          ></app-site-disk-usage>
          <app-bandwidth [websiteData]="data"></app-bandwidth>
        </div>

        <app-group-information [websiteData]="data"></app-group-information>
      }

      <app-site-history></app-site-history>
    </div>
  </mat-tab>
  <mat-tab label="SSL Certificates">
    <div class="overview">
      @if (certificates$ | async; as certificates) {
        <app-ssl-certificates
          [website]="website()"
          [certificates]="certificates"
        ></app-ssl-certificates>
      }
    </div>
  </mat-tab>
  <mat-tab label="CDN & Redis">
    <div class="cdn row">
      @if (websiteData(); as data) {
        <app-cdn-vhost [websiteData]="data"></app-cdn-vhost>
        <app-redis [website]="data.website"></app-redis>
      }
    </div>
  </mat-tab>
  <mat-tab label="VHost & PHP">
    <div class="v-host row">
      @if (websiteData(); as data) {
        <app-origin-vhost [websiteData]="data"></app-origin-vhost>
        <app-php [websiteData]="data"></app-php>
      }
    </div>
  </mat-tab>
  <mat-tab label="DNS Zone">
    @if (websiteData(); as data) {
      <div class="dns-zone">
        <app-dns-zone [websiteData]="data"></app-dns-zone>
      </div>
    }
  </mat-tab>
  <mat-tab label="Email">
    @if (websiteData(); as data) {
      <div class="email">
        <app-mailbox [websiteData]="data"></app-mailbox>
      </div>
    }
  </mat-tab>
  <mat-tab label="Databases">
    @if (websiteData(); as data) {
      <div class="databases">
        <app-databases [websiteData]="data"></app-databases>
      </div>
    }
  </mat-tab>
  <mat-tab label="FTP Users">
    @if (websiteData(); as data) {
      <div class="ftp-users">
        <app-ftp-users [websiteData]="data"></app-ftp-users>
      </div>
    }
  </mat-tab>
  <mat-tab label="Backups">
    @if (websiteData(); as data) {
      <div class="backups">
        <app-backups [websiteData]="data"></app-backups>
      </div>
    }
  </mat-tab>
  <mat-tab label="Restores">
    @if (websiteData(); as data) {
      <div class="restores">
        <app-restores [websiteData]="data"></app-restores>
      </div>
    }
  </mat-tab>
</mat-tab-group>
